import type { ReactNode } from 'react';

import type {
  XYChartSelectedDomains,
  XYChartSelectedSeries,
} from '../types/xy-chart.js';

/**
 * The Select subcomponent props
 * @public
 */
export interface XYChartSelectProps {
  /**
   * When `true`, suppresses pointer-based drag-to-select gestures.
   * No selection tooltip appears while the prop is set.
   * @defaultValue false
   */
  disabled?: boolean;
  /**
   * Custom actions handler
   * @param selectedSeries - A record mapping series keys to their data points.
   * @param selectionDomain - A record mapping axis keys to their selected domain ranges.
   * @returns ReactNode to render as custom actions.
   */
  actions?: (
    selectedSeries: XYChartSelectedSeries,
    selectionDomain: XYChartSelectedDomains,
  ) => ReactNode | Promise<ReactNode>;
}

/**
 * Select slot component.
 * @public
 */
export const Select = (props: XYChartSelectProps) => null;

Select['displayName'] = 'XYChart.Select';
